import React from 'react'
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes'
import ScrollTopButton from './components/ScrollTopButton'

// CSS is loaded in index.html to avoid duplicate loading and improve performance
// Only import custom CSS that's not in index.html
import './assets/css/hiredots.css'


function App() {
  return (
    <>
      <Router>
        <Routing />
        <ScrollTopButton />
      </Router>
    </>
  );
}

export default App